var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"sidebar"},[_c('sidebarComponent')],1),_c('div',{staticClass:"content-right"},[_c('navbarComponent'),_c('div',{staticClass:"pages"},[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }